import { ArrowLeftOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ReportCatalog } from "./ReportConfigurationPreview/components/ReportCatalog";
import { WorkbookPreview } from "./ReportConfigurationPreview/components/WorkbookPreview";
import { useReportCatalog } from "./ReportConfigurationPreview/state/useReportCatalog";
import { useReportPreview } from "./ReportConfigurationPreview/state/useReportPreview";
import type { PreviewFilters, PreviewReport } from "./ReportConfigurationPreview/types";
import "./reportConfiguration.scss";
import "./ReportConfigurationPreview/reportConfigurationPreview.scss";

const basePath = "/Reports/ReportConfiguration/Preview";
const positiveInteger = (value: string | null | undefined) => value && /^\d+$/.test(value) && Number.isSafeInteger(Number(value)) ? Number(value) : 0;

export default function ReportConfigurationPreview() {
    useEffect(() => { document.title = "Report Preview"; }, []);
    const navigate = useNavigate();
    const { reportId: reportParam } = useParams();
    const [params, setParams] = useSearchParams();
    const reportId = positiveInteger(reportParam);
    const filters: PreviewFilters = {
        search: params.get("search") || "", clientId: params.get("clientId") || "", folderId: params.get("folderId") || "",
        effectiveFrom: params.get("effectiveFrom") || "", effectiveTo: params.get("effectiveTo") || "",
        page: positiveInteger(params.get("page")) || 1,
    };
    const catalog = useReportCatalog(filters);
    const preview = useReportPreview(reportId);
    const change = (values: Partial<PreviewFilters>) => {
        const next = new URLSearchParams(params);
        next.delete("version"); next.delete("statusId"); next.delete("planId");
        Object.entries(values).forEach(([key, value]) => value === "" ? next.delete(key) : next.set(key, String(value)));
        if (!values.page) next.delete("page");
        setParams(next, { replace: true });
    };
    const open = (report: PreviewReport) => {
        const next = new URLSearchParams(params); next.delete("version"); next.delete("statusId"); next.delete("planId");
        navigate(`${basePath}/${report.reportId}?${next}`);
    };
    const back = () => { const next = new URLSearchParams(params); next.delete("version"); navigate(`${basePath}?${next}`); };
    const currentIndex = catalog.catalog.items.findIndex(r => r.reportId === reportId);
    return <main className={`rcp-page${reportId ? " rcp-page--preview" : ""}`}>
        <header className="rcp-header"><div><div className="rcp-eyebrow">Report Configurator</div><h1>Reports Preview</h1>
            <p className="rcp-muted">Your reports, ready to explore. Find the details you need and download a copy.</p></div>
            {reportId > 0 && <div className="rcp-actions"><button onClick={back}><ArrowLeftOutlined aria-hidden="true" /> All reports</button>
                {currentIndex >= 0 && <><button disabled={currentIndex === 0} onClick={() => open(catalog.catalog.items[currentIndex - 1])}><LeftOutlined aria-hidden="true" /> Previous report</button>
                    <button disabled={currentIndex === catalog.catalog.items.length - 1} onClick={() => open(catalog.catalog.items[currentIndex + 1])}>Next report <RightOutlined aria-hidden="true" /></button></>}
            </div>}
        </header>
        {reportParam && !reportId ? <div className="rcp-state" role="alert">Invalid report link. <button onClick={back}>Browse reports</button></div>
            : reportId ? <WorkbookPreview preview={preview} /> : <ReportCatalog filters={filters} {...catalog} change={change} open={open} />}
    </main>;
}
